// extracted by mini-css-extract-plugin
export default {"image":"JRVaoC","content":"vHguON"};